import { createAsyncThunk } from "@reduxjs/toolkit";
import * as helpService from "./help.service";
import {
  GetHelpCategoriesRequest,
  SubmitHelpVoteRequest,
} from "./help.types";
import { handleApiError } from "@/app/utils/handleApiError";

/**
 * Fetch help categories
 */
export const getHelpCategories = createAsyncThunk(
  "help/getCategories",
  async (params: GetHelpCategoriesRequest | undefined, { rejectWithValue }) => {
    try {
      const response = await helpService.fetchHelpCategories(params);
      return response;
    } catch (error) {
      return rejectWithValue(handleApiError(error));
    }
  }
);

/**
 * Fetch help content by slug
 */
export const getHelpContent = createAsyncThunk(
  "help/getContent",
  async (slug: string, { rejectWithValue }) => {
    try {
      const response = await helpService.fetchHelpContent(slug);
      return response;
    } catch (error) {
      return rejectWithValue(handleApiError(error));
    }
  }
);

/**
 * Submit help vote
 */
export const submitVote = createAsyncThunk(
  "help/submitVote",
  async (data: SubmitHelpVoteRequest, { rejectWithValue }) => {
    try {
      const response = await helpService.submitHelpVote(data);
      return response;
    } catch (error) {
      return rejectWithValue(handleApiError(error));
    }
  }
);